import React from 'react';
import { Container } from 'semantic-ui-react';

/**
 * Fixed-position FAB row aligned to the same width/centering as AppHeader + main shell (.ui.container).
 */
export default function ContainerFixedFab({ children, bottom = '80px' }) {
  return (
    <div className="app-fab-anchor" style={{ bottom }}>
      <Container>
        <div className="app-fab-anchor__row">
          {children}
        </div>
      </Container>
    </div>
  );
}
